'use client'

import { useState } from 'react'
import HeaderWithBackButton from '@/components/common/HeaderWithBackButton'
import { useTranslation } from 'react-i18next'
import { NOTICE_CATEGORIES, NOTICE_DATA } from '@/constants/notice'
import NoticeItem from '@/app/notice/_components/NoticeItem'
import { GA_EVENTS } from '@/utils/analytics'

const Notice = () => {
  const [selectedCategory, setSelectedCategory] = useState<string>('all')

  const { t } = useTranslation('notice')

  const handleCategoryClick = (category: string) => {
    setSelectedCategory(category)
    GA_EVENTS.BUTTON_CLICK(`notice_category_${category}`)
  }

  const filteredNotice =
    selectedCategory === 'all'
      ? NOTICE_DATA
      : NOTICE_DATA.filter((notice) => notice.category === selectedCategory)

  return (
    <section>
      <div className="sm:hidden">
        <HeaderWithBackButton />
      </div>
      <div className="hidden sm:flex mt-[128px] justify-center">
        <h2 className="font-pretendard-bold text-[62px] text-black dark:text-white">
          {t('notice_header')}
        </h2>
      </div>
      <div className="mx-auto px-5 sm:mt-[56px] mt-6">
        <div>
          <div className="flex flex-wrap gap-[14px] sm:justify-center">
            {NOTICE_CATEGORIES.map((category, index) => (
              <button
                key={index}
                type="button"
                onClick={() => handleCategoryClick(category)}
                className={`text-[15px] ${
                  selectedCategory === category
                    ? 'text-primary border-b-2 border-primary font-pretendard-bold'
                    : 'text-main-light-1 dark:text-main-dark-1'
                }`}
              >
                {t(category)}
              </button>
            ))}
          </div>
        </div>
        <div className="flex flex-col sm:mt-[42px] max-w-[1440px] mx-auto">
          <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 sm:gap-x-[47px] sm:gap-y-10">
            {filteredNotice.length > 0 ? (
              filteredNotice.map((notice) => (
                <NoticeItem key={notice.id} notice={notice} />
              ))
            ) : (
              <li className="py-4 font-pretendard-regular text-[15px] text-main-light-2 dark:text-main-dark-2">
                {t('notice_text_1')}
              </li>
            )}
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Notice
